<!-- cookie consent -->
<div
  id="cookieConsdentModal"
  #cookieConsdentModal
  tabindex="-1"
  [@animateMoadl]="animateState"
  class="hidden overflow-y-auto overflow-x-hidden fixed top-0 right-0 left-0 z-50 justify-center items-center w-full inset-0"
>
  <div class="relative p-4 w-full max-w-2xl">
    <!-- Modal content -->
    <div class="relative bg-white rounded-2xl shadow dark:bg-gray-700">
      <!-- Modal header -->
      <div class="flex items-center justify-between p-4 md:p-5 border-b rounded-t dark:border-gray-600">
        <div class="flex flex-row items-center justify-start">
          <div class="md:flex md:flex-row items-center mr-1 xs:mr-0">
            <button
              type="button"
              #languageDropdownButton
              class="inline-flex items-center justify-center font-medium px-2 py-1 sm:px-4 sm:py-2 text-sm text-black dark:text-white rounded-md cursor-pointer hover:bg-gray-100 dark:hover:bg-gray-700 dark:hover:text-white"
            >
            @if((activeLanguage | async) === 'fa'){
              <div class="inline-flex items-center">
                <img
                  class="w-5 h-5 rounded-full lg:me-3"
                  src="assets/icons/flags/fa.svg"
                  alt="iranian flag"
                />
                <span class="hidden lg:block">فارسی</span>
              </div>
            } @else if((activeLanguage | async) === 'de'){
              <div class="inline-flex items-center">
                <img
                  class="w-5 h-5 rounded-full lg:me-3"
                  src="assets/icons/flags/de.svg"
                  alt="german flag"
                />
                <span class="hidden lg:block">Deutsch</span>
              </div>
            } @else if((activeLanguage | async) === 'en') {
              <div class="inline-flex items-center">
                <img
                  class="w-5 h-5 rounded-full lg:me-3"
                  src="assets/icons/flags/en.svg"
                  alt="uk flag"
                />
                <span class="hidden lg:block">English</span>
              </div>
            }
            </button>
            <div
              #languageDropdownMenu
              class="hidden my-4 z-50 text-base list-none bg-white divide-y divide-gray-100 border-2 rounded-md shadow dark:bg-gray-700"
            >
              <ul class="py-2 font-medium" role="none">
                <li class="hover:cursor-pointer">
                  <a
                    (click)="setLanguage('en')"
                    class="block px-4 py-2 text-sm text-black hover:bg-gray-100 dark:text-white dark:hover:bg-gray-600 dark:hover:text-white"
                    role="menuitem"
                  >
                    <div class="inline-flex items-center">
                      <img
                        class="w-5 h-5 rounded-full me-3"
                        src="assets/icons/flags/en.svg"
                        alt="uk flag"
                        loading="lazy"
                      />
                      English
                    </div>
                  </a>
                </li>
                <li class="hover:cursor-pointer">
                  <a
                    (click)="setLanguage('de')"
                    class="block px-4 py-2 text-sm text-black hover:bg-gray-100 dark:text-white dark:hover:bg-gray-600 dark:hover:text-white"
                    role="menuitem"
                  >
                    <div class="inline-flex items-center">
                      <img
                        class="w-5 h-5 rounded-full me-3"
                        src="assets/icons/flags/de.svg"
                        alt="german flag"
                        loading="lazy"
                      />
                      Deutsch
                    </div>
                  </a>
                </li>
                <li class="hover:cursor-pointer">
                  <a
                    (click)="setLanguage('fa')"
                    class="block px-4 py-2 text-sm text-black hover:bg-gray-100 dark:text-white dark:hover:bg-gray-600 dark:hover:text-white"
                    role="menuitem"
                  >
                    <div class="inline-flex items-center">
                      <img
                        class="w-5 h-5 rounded-full me-3"
                        src="assets/icons/flags/fa.svg"
                        alt="iranian"
                        loading="lazy"
                      />
                      فارسی
                    </div>
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>



        <div class="sm:text-xl dark:text-white">
          <h1>{{"COOKIE-CONSENT.HEADER" | translate }}</h1>
        </div>
        <button
          type="button"
          class="end-2.5 text-gray-400 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg text-sm w-8 h-8 inline-flex justify-center items-center dark:hover:bg-gray-600 dark:hover:text-white"
          (click)="closeCookieConsdentModal()"
        >
          <svg
            class="w-3 h-3"
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 14 14"
          >
            <path
              stroke="currentColor"
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="m1 1 6 6m0 0 6 6M7 7l6-6M7 7l-6 6"
            />
          </svg>
          <span class="sr-only mb-4 text-xl font-semibold dark:text-white">Close modal</span>
        </button>
      </div>

    <!-- Modal body -->
      <form [formGroup]="cookieSettingsForm" (ngSubmit)="onFormSubmit()">
        <div [dir]="languageDirection" class="border-b border-gray-200 dark:border-gray-700">
          <ul class="flex flex-grow max-h-20 justify-evenly -mb-px text-sm font-medium text-center text-gray-500 dark:text-gray-400" id="tabs" #tabs role="tablist">
              <li style="width: calc(100% / 3);" role="presentation">
                  <button
                      class="inline-block p-3 border-b-2 border-transparent rounded-t-lg hover:text-gray-600 hover:border-gray-300 dark:hover:text-gray-300"
                      id="approvalTab"
                      #approvalTab
                      type="button"
                      role="tab"
                      aria-controls="approvalTabContent"
                      aria-selected="false"
                  >
                    {{"COOKIE-CONSENT.TABS.APPROVAL" | translate }}
                  </button>
              </li>
              <li style="width: calc(100% / 3);" role="presentation">
                  <button
                      class="inline-block p-3 border-b-2 border-transparent rounded-t-lg hover:text-gray-600 hover:border-gray-300 dark:hover:text-gray-300"
                      id="detailsTab"
                      #detailsTab
                      type="button"
                      role="tab"
                      aria-controls="detailsTabContent"
                      aria-selected="false"
                  >
                    {{"COOKIE-CONSENT.TABS.SETTINGS" | translate }}
                  </button>
              </li>
              <li style="width: calc(100% / 3);" role="presentation">
                  <button
                      class="inline-block p-3 border-b-2 border-transparent rounded-t-lg hover:text-gray-600 hover:border-gray-300 dark:hover:text-gray-300"
                      id="aboutCookiesTab"
                      #aboutCookiesTab
                      type="button"
                      role="tab"
                      aria-controls="aboutCookiesTabContent"
                      aria-selected="false"
                  >
                    {{"COOKIE-CONSENT.TABS.ABOUT" | translate }}
                  </button>
              </li>
          </ul>
        </div>
        <div id="tabContent" [dir]="languageDirection">
          <div
              class="hidden bg-gray-50 p-4 dark:bg-gray-800 max-h-[65dvh] overflow-auto"
              id="approvalTabContent"
              #approvalTabContent
              role="tabpanel"
              aria-labelledby="profile-tab-example"
          >
              <p class="text-sm sm:px-8 text-gray-500 dark:text-gray-400">
                {{"COOKIE-CONSENT.APPROVAL.APPROVAL-DESCRIPTION-1" | translate }}
                <br>
                <br>
                {{"COOKIE-CONSENT.APPROVAL.APPROVAL-DESCRIPTION-2" | translate }}
              </p>
          </div>
          <div
              class="hidden bg-gray-50 p-4 dark:bg-gray-800 max-h-[65dvh] overflow-auto"
              id="detailsTabContent"
              #detailsTabContent
              role="tabpanel"
              aria-labelledby="dashboard-tab-example"
          >
            <div class="flex items-center justify-between py-4">
              <div class="flex flex-col flex-grow">
                <div class="flex flex-row justify-between">
                  <div class="text-lg font-semibold text-gray-900 dark:text-white">
                    {{"COOKIE-CONSENT.SETTINGS.ESSENTIALS" | translate }}
                  </div>
                  <div>
                    <label
                    for="Essentials"
                    class="relative flex items-center opacity-50 cursor-not-allowed"
                    >
                      <input type="checkbox" id="Essentials" class="sr-only " disabled="true" checked/>
                      <span
                        class="h-6 bg-gray-200 border border-gray-200 rounded-full w-11 toggle-bg dark:bg-gray-700 dark:border-gray-600"
                      ></span>
                    </label>
                  </div>
                </div>
                <div class="text-base font-normal text-gray-500 dark:text-gray-400">
                  {{"COOKIE-CONSENT.SETTINGS.ESSENTIALS-DESCRIPTION" | translate }}
                </div>
              </div>
            </div>
            <div class="flex items-center justify-between py-4">
              <div class="flex flex-col flex-grow">
                <div class="flex flex-row justify-between">
                  <div class="text-lg font-semibold text-gray-900 dark:text-white">
                    {{"COOKIE-CONSENT.SETTINGS.STATISTICS" | translate }}

                  </div>
                  <div>
                    <label
                    for="statistics"
                    class="relative flex items-center cursor-pointer"
                    >
                      <input formControlName="statistik"  id="statistics" type="checkbox" value="" class="sr-only peer" checked/>
                      <span
                        class="h-6 bg-gray-200 border border-gray-200 rounded-full w-11 toggle-bg dark:bg-gray-700 dark:border-gray-600"
                      ></span>
                    </label>
                  </div>
                </div>
                <div class="text-base font-normal text-gray-500 dark:text-gray-400">
                  {{"COOKIE-CONSENT.SETTINGS.STATISTICS-DESCRIPTION" | translate }}
                </div>
              </div>
            </div>
            <div class="flex items-center justify-between py-4">
              <div class="flex flex-col flex-grow">
                <div class="flex flex-row justify-between">
                  <div class="text-lg font-semibold text-gray-900 dark:text-white">
                    {{"COOKIE-CONSENT.SETTINGS.MARKETING" | translate }}
                  </div>
                  <div>
                    <label
                    for="marketing"
                    class="relative flex items-center cursor-pointer"
                    >
                      <input formControlName="statistik"  id="marketing" type="checkbox" value="" class="sr-only peer" checked/>
                      <span
                      class="h-6 bg-gray-200 border border-gray-200 rounded-full w-11 toggle-bg dark:bg-gray-700 dark:border-gray-600"
                      ></span>
                    </label>
                  </div>
                </div>
                <div class="text-base font-normal text-gray-500 dark:text-gray-400">
                  {{"COOKIE-CONSENT.SETTINGS.MARKETING-DESCRIPTION" | translate }}
                </div>
              </div>
            </div>
          </div>
          <div
              class="hidden bg-gray-50 max-h-[65dvh] p-4 dark:bg-gray-800"
              id="aboutCookiesTabContent"
              #aboutCookiesTabContent
              role="tabpanel"
              aria-labelledby="settings-tab-example"
          >
              <p class="text-sm text-gray-500 dark:text-gray-400">
                {{"COOKIE-CONSENT.ABOUT.ABOUT-DESCRIPTION-1" | translate }}
                <br>
                <br>
                {{"COOKIE-CONSENT.ABOUT.ABOUT-DESCRIPTION-2" | translate }}
                <br>
                <br>
                {{"COOKIE-CONSENT.ABOUT.ABOUT-DESCRIPTION-3" | translate }}
              </p>
          </div>
        </div>

        <!-- buttons section -->
        <div class="flex items-center justify-end p-4 md:p-5 border-t border-gray-200 rounded-b dark:border-gray-600">
          <button
            (click)="goToSettings()"
            type="button"
            class="hover:bg-gray-100 focus:ring-4 focus:outline-none focus:ring-blue-300 rounded-lg text-xs sm:text-sm font-medium px-2 sm:px-5 sm:py-2.5 mr-2 hover:text-gray-900 focus:z-10 text-gray-500 dark:text-gray-300 dark:hover:text-white dark:hover:bg-gray-600 dark:focus:ring-gray-600"
          >
          {{"COOKIE-CONSENT.GO-TO-SETTINGS" | translate }}
          </button>
          <button
          type="button"
          (click)="acceptEssentials()"
          class="hidden sm:block text-gray-500 bg-white hover:bg-gray-100 focus:ring-4 focus:outline-none focus:ring-blue-300 rounded-lg text-xs sm:text-sm font-medium px-5 py-2.5 mr-2 hover:text-gray-900 focus:z-10 dark:bg-gray-700 dark:text-gray-300 dark:hover:text-white dark:hover:bg-gray-600 dark:focus:ring-gray-600">
            {{"COOKIE-CONSENT.ACCEPT-ESSENTIALS" | translate }}
          </button>
          <button
          type="button"
          (click)="acceptAll()"
          class="text-white bg-primary-700 hover:bg-primary-800 focus:ring-4 focus:ring-primary-300 font-medium rounded-lg text-xs sm:text-sm px-5 py-2.5 text-center dark:bg-primary-600 dark:hover:bg-primary-700 dark:focus:ring-primary-800">
            {{"COOKIE-CONSENT.ACCEPT-ALL" | translate }}
          </button>
        </div>
      </form>
    </div>
  </div>
</div>
